import type { DCCTVolumeStatus } from '../config';

export const isDCCTVolumeUsable = (status: DCCTVolumeStatus) =>
  status !== 'missing' && status !== 'failed';
